import { useQuery } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';
import { eventMetricsQueryKeys } from './query-keys';

export const useEventMetricsQuery = (options = {}) => {
  const { enabled = true } = options;
  const { api, features } = useEventsScope();
  const getEventMetrics = api.getEventMetrics;

  return useQuery({
    queryKey: eventMetricsQueryKeys.metrics(),
    enabled: enabled && features.showMetrics && Boolean(getEventMetrics),
    queryFn: async () => {
      const result = await getEventMetrics();

      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch event metrics');
      }

      return result.data;
    },
  });
};
